/**
 * Configuration host to call apis
 */
// Check README.md for details on how to setup your dev api access
const useZywaveApiPath = true;

const apiHost =
  process.env.NODE_ENV === 'development' || process.env.REACT_APP_ENV === 'dev'
    ? useZywaveApiPath
      ? 'https://test-miedge.zywave.com'
      : 'https://test.miedge.net'
    : '';

const supportCenterURLZywave = 'https://support.zywave.com/';

/**
 * URI for zywave-api-proxy component
 */
let zywaveProxyUrl = '';
if (
  process.env.REACT_APP_ENV === 'test' ||
  process.env.REACT_APP_ENV === 'dev' ||
  process.env.NODE_ENV === 'development'
)
  zywaveProxyUrl = 'https://qa-api.zywave.com/proxy/';
if (process.env.REACT_APP_ENV === 'staging') zywaveProxyUrl = 'https://pre-api.zywave.com/proxy/';
if (process.env.REACT_APP_ENV === 'prod') zywaveProxyUrl = 'https://api.zywave.com/proxy/';

/**
 * Base Url for the Joomla website
 */

/**
 * URI for zywave component
 */
let amsZywaveUrl = '';
if (
  process.env.REACT_APP_ENV === 'test' ||
  process.env.REACT_APP_ENV === 'dev' ||
  process.env.NODE_ENV === 'development'
)
  amsZywaveUrl =
    process.env.REACT_APP_ENV === 'dev'
      ? 'https://dev-accounts.zywave.com/'
      : 'https://qa-accounts.zywave.com/';
if (process.env.REACT_APP_ENV === 'staging') amsZywaveUrl = 'https://pre-accounts.zywave.com/';
if (process.env.REACT_APP_ENV === 'prod') amsZywaveUrl = 'https://accounts.zywave.com/';

/**
 * Configuration parameters for the app
 */
const AppConfig = {
  /**
   * The URL for all calls
   */
  apiUrl: apiHost + '/api',
  loginUrl: apiHost + '/api/v1/auth/login',
  internalApiUrl: apiHost + '/api/internal/v1',
  findUserInfoUrl: apiHost + '/api/v1/auth/data',
  logoutUrl:
    process.env.NODE_ENV === 'development' || process.env.REACT_APP_ENV === 'dev'
      ? '/edge/login'
      : '/app/login/logout',
  zywaveProxyUrl: zywaveProxyUrl,
  currentBranch: process.env.BRANCH_NAME,

  /**
   * Support center urls
   *
   */
  supportCenterURLZywave: supportCenterURLZywave,

  /**
   * URL for the LOB Doc
   */
  LOBDocURL:
    supportCenterURLZywave + 's/article/How-do-I-search-for-Insurance-Lines-of-Business-miEdge',

  /**
   * Tooltip info text used for Line of Business
   */
  LOBTooltipInfoText:
    'Searches brokers and broker locations that have at least one client that does/does not have the selected line(s) of business.',

  LOBCompanyTooltipInfoText:
    'Searches companies that do/do not have the selected line(s) of business.',

  /**
   * Ams Zywave urls
   *
   */
  amsZywaveUrl: amsZywaveUrl,

  /**
   * Learn more about alerts url
   */
  learnMoreAboutAlertsURL: 'https://www.loom.com/share/adea19f085874ad09c339c0f2df03836',

  /**
   * Feature Toggles
   */

  // A feature for ignoring quality score when searching for entities.
  // This is not enabled for end users, only for internal users.
  // The test runner doesn't support local storage, so we default to disabling this feature.
  // Enable or disable the feature in your browser console then refresh the page.
  // Enable: localStorage.setItem("enableBypassQualityScoreFilter", true)
  // Disable: localStorage.setItem("enableBypassQualityScoreFilter", false)
  enableBypassQualityScoreFilter:
    window && window.localStorage
      ? window.localStorage.getItem('enableBypassQualityScoreFilter') === 'true'
      : false,

  // bool: Adds a miEdge-request-id header to outgoing requests for debugging purposes.
  // This is disabled on dev because it isn't compatible with CORS requests (not in Access-Control-Allow-Headers)
  // This is disabled on prod because we don't need it on production right now.
  enableMiedgeRequestId:
    process.env.REACT_APP_ENV !== 'prod' && process.env.REACT_APP_ENV !== 'dev',

  // Feature Toggle: bool: Whether to enable showing error log
  enableShowErrorLog: false, //process.env.REACT_APP_ENV === 'test' || process.env.REACT_APP_ENV === 'dev',

  // Whether to report HTTP 403 responses as Sentry issues or to redirect the user to the forbidden page
  // https://github.com/miEdge/app.miedge/issues/71
  enableForbiddenPageOn403:
    process.env.REACT_APP_ENV === 'test' || process.env.REACT_APP_ENV === 'dev',

  // handle Support center links for Zywave users
  // https://github.com/miEdge/app.newEdge/issues/818
  enableSupportCenterLinks:
    ['test-miedge.zywave.com', 'staging-miedge.zywave.com', 'miedge.zywave.com'].includes(
      window.location.hostname
    ) === false,

  // [PC] Update PEO/Admin details for P&C Policies
  // https://github.com/miEdge/app.newEdge/issues/879
  enableUpdatePEOAdminPC: false, //process.env.REACT_APP_ENV === 'test' || process.env.REACT_APP_ENV === 'dev',

  // Since MFA is disabled - hide the Phone controls in the 'My Account' page
  // https://github.com/miEdge/app.newEdge/issues/941
  enableDisplayMFAComponents: false,

  // redirect zywave.com users to root
  enableRedirectZywaveDotCom: true,

  // auto-refresh when new version
  enableAutoRefreshNewVersion: true,

  // https://zywave-rd.atlassian.net/browse/EDP-1423
  enableShowInsightTabEmptyState:
    process.env.REACT_APP_ENV === 'test' || process.env.REACT_APP_ENV === 'dev',

  // https://zywave-rd.atlassian.net/browse/EDP-2045
  enableBrokerLocationsPagination:
    process.env.REACT_APP_ENV === 'test' || process.env.REACT_APP_ENV === 'dev',

  /**
   * Centralized session expiration message to follow DRY principle
   * This message is conditionally applied based on enableRedirectZywaveDotCom flag
   * Used in multiple components: Layout, LayoutTabs, AlternateAddressesTable, TrackExports
   *
   * Different messages are displayed based on user type and URL:
   * - Zywave users (account_type === 7) or zywave.com URLs get Zywave-specific messaging
   * - Other users get standard miEdge messaging
   */
  sessionExpiredMessages: {
    primary: 'Your session has expired or your account was used to log in from another browser.',
    secondary: 'You will be redirected to the login page.',
    // Zywave-specific messages for Zywave users (account_type === 7) or zywave.com URLs
    zywave: {
      primary: 'Your session has expired. Refreshing your session now...',
    },
  },
};

export default AppConfig;
